export const setApiURL = (apiURL) => {
    if (apiURL) {
        return apiURL;
    }

    if (typeof window === "undefined") {
        return "http://localhost:3333";
    }

    const { hostname, protocol } = window.location;
    return `${protocol}//${hostname}:3333`;
};
